// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileModalContainer_Udwlg {
  height: fit-content;
  position: sticky;
  top: 81px;
display: flex;
align-items: center;
justify-content: center;
    @media (width<=768px) {
      position: initial;
      width: fit-content;
      width:90% !important;
      height:90% !important;
        margin: 0 auto;
  }
}

.initials_qNJ6r,.profileImage_iQhNF{
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex
;
  align-items: center;
  justify-content: center;
  background: var(--_16c098-background);
  color: var(--white-color);
  font-size: clamp(16px, 2vw, 20px);
  font-weight: 600;
}
.profileModalTemplate_ETK6T {
  height: 200px;
  width: 200px;
  overflow: hidden;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  position: relative;
  @media (width <= 768px) {
    width:90% !important;
    height:90% !important;
  }
  &:hover{
    .camContainer_s1xCj{
      display: flex;
    }
  }
  .camContainer_s1xCj {
    position: absolute;
    display: none;
    width: 100%;
    justify-content: center;
    height: 40%;
    left: 50%;
    bottom: 0px;
    background-color: var(--9e9e9e-background);
    transform: translate(-50%);
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);
    -ms-transform: translate(-50%);
    -o-transform: translate(-50%);
    padding-top: 10px;
    box-sizing: border-box;
    .icon_nI5cu {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ProfileModalTemplate/ProfileModalTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX,aAAa;AACb,mBAAmB;AACnB,uBAAuB;IACnB;MACE,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB;MACpB,qBAAqB;QACnB,cAAc;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB;AACF;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;IACtB;MACE,YAAY;MACZ,WAAW;MACX,eAAe;IACjB;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":[".profileModalContainer {\n  height: fit-content;\n  position: sticky;\n  top: 81px;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\n    @media (width<=768px) {\n      position: initial;\n      width: fit-content;\n      width:90% !important;\n      height:90% !important;\n        margin: 0 auto;\n  }\n}\n\n.initials,.profileImage{\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  display: flex\n;\n  align-items: center;\n  justify-content: center;\n  background: var(--_16c098-background);\n  color: var(--white-color);\n  font-size: clamp(16px, 2vw, 20px);\n  font-weight: 600;\n}\n.profileModalTemplate {\n  height: 200px;\n  width: 200px;\n  overflow: hidden;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  position: relative;\n  @media (width <= 768px) {\n    width:90% !important;\n    height:90% !important;\n  }\n  &:hover{\n    .camContainer{\n      display: flex;\n    }\n  }\n  .camContainer {\n    position: absolute;\n    display: none;\n    width: 100%;\n    justify-content: center;\n    height: 40%;\n    left: 50%;\n    bottom: 0px;\n    background-color: var(--9e9e9e-background);\n    transform: translate(-50%);\n    -webkit-transform: translate(-50%);\n    -moz-transform: translate(-50%);\n    -ms-transform: translate(-50%);\n    -o-transform: translate(-50%);\n    padding-top: 10px;\n    box-sizing: border-box;\n    .icon {\n      height: 30px;\n      width: 30px;\n      cursor: pointer;\n    }\n  }\n\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileModalContainer": `profileModalContainer_Udwlg`,
	"initials": `initials_qNJ6r`,
	"profileImage": `profileImage_iQhNF`,
	"profileModalTemplate": `profileModalTemplate_ETK6T`,
	"camContainer": `camContainer_s1xCj`,
	"icon": `icon_nI5cu`
};
export default ___CSS_LOADER_EXPORT___;
